import * as React from 'react';
import { useContext, useEffect, useRef, useState } from 'react';
import { Accordion, AccordionContext, Button, Card, Collapse, useAccordionToggle } from 'react-bootstrap';
import { FilterAction } from '../../services/filter-controller';
import { addFilterCounts } from '../../utility/api-utilities';
import { AppContext } from '../school-search-app';
import AgeCalculator from './age-calculator';
import InfoBubble from '../info/info-bubble';
export interface ICpsPageComponentProps {
    mode: string
}
import { PAGE_MODE } from "../../interfaces"


function FilterLink({ children, eventKey, callback, info }) {
    const currentEventKey = useContext(AccordionContext);

    const decoratedOnClick = useAccordionToggle(
        eventKey,
        () => callback && callback(eventKey),
    );
    const infoBubble = info ? <InfoBubble index={eventKey} tip={info} placement={'right'} /> : <></>;
    const active = currentEventKey === eventKey;

    return <div className="filter-link">
        <div>{children} {infoBubble}</div><button onClick={decoratedOnClick}><i className={`fa fa-${active ? 'minus' : 'plus'}`}></i></button>
    </div>
}

export interface IFilterFormProps {
    //changeFilter: (field: string, term: string, enabled: boolean) => void,
    //facets: any[] // @TODO type this out with the full epi interface,
    //mode: string,
    reset: number;
    //resetSearch: () => void
    isShow: number;
}

function FilterForm({ reset, isShow }: IFilterFormProps) {
    const [show, setShow] = useState(false)
    const appContext = useContext(AppContext);
    // @todo this is not at all the right way to do this
    const ageCalcRef = useRef<any>();
    useEffect(() => {
        if (ageCalcRef.current) {
            ageCalcRef.current.reset()
        }
    }, [reset])

    useEffect(() => {
        setShow(!!isShow);
    }, [isShow]);
    useEffect(() => {
        appContext.setIsShowFilterWindow(show);
    }, [show]);

    useEffect(() => {
        appContext.tourOpen && setShow(false)
    }, [appContext.tourOpen])

    useEffect(() => {
        if (!appContext.isShowFilterWindow) {
            setShow(false);
        }
    }, [appContext.isShowFilterWindow])

    const setAgeFilter = (age) => {
        // find any term that has age in it and check it
        const ageFilter = appContext.filterController.filters.filter(f => f.fieldName == 'PrenatalServicesFacet');
        if (ageFilter.length == 0) return;

        for (let t of ageFilter[0].terms) {
            change('PrenatalServicesFacet', t.term, false)
        }
        if (age == 0) {
            age = 'Birth';
        }
        if (age < 0) {
            age = 'Prenatal'
        }
        const term = ageFilter[0].terms.filter(t => t.displayName.includes('' + age));
        if (term.length == 0) return;


        change('PrenatalServicesFacet', term[0].term, true)
    }

    let change = (option, term, enabled) => {
        if (option && option.startsWith('HSCRPrograms')) {
            option.replace('HSCRPrograms', 'hscrPrograms');
        }
        if (option && option.startsWith('CTEPrograms')) {
            option.replace('CTEPrograms', 'ctePrograms');
        }


        //changeFilter(option, term, enabled); // normalize where we remove the prefix
        appContext.filterControllerDispatch({
            action: FilterAction.CHANGE_FILTER,
            filter: option,
            term: term,
            enabled: enabled
        })
        if (enabled && (option == 'AddressZipCodeFormatted' || option == 'PostalCode')) {
            appContext.addZipOverlay(term)
        } else if (enabled && option == 'Community') {
            appContext.addCommunityOverlay(term);
        } else if (option == 'Network' || option == 'GeographicNetwork') {
            enabled
                ? appContext.addNetworkOverlay(term)
                : appContext.resetOverlay()
        } else {
            appContext.setCenteredMap(true)
        }
       
        checkOverlay(option);
    };

    let checkOverlay = (option) => {
        const checkFilter = (optionName) => {
            const filterObj = appContext.filterController.filters.find(i => i.fieldName === optionName);
            return filterObj.terms.filter(i => i.enabled).length;
        }
        if (option == 'AddressZipCodeFormatted' || option == 'PostalCode' || option == 'Community' || option == 'Network' || option == 'GeographicNetwork') {
            checkFilter(option) === 0 && appContext.resetOverlay()
        }
    }

    let finalFilters = addFilterCounts(appContext.filterController.filters, appContext.resultSchools)

    const filterDom = (facets) => facets.filter(facet => facet.fieldName != 'id').map((facet, idx) => {
        //always sort filter terms for gocps and prek modes. sort all in program mode except grades served and GeographicNetwork
        if (facet.fieldName != 'GradesServed' && facet.fieldName != 'GeographicNetwork') {
            facet.terms.sort((a, b) => a.displayName.localeCompare(b.displayName));
        }
        return <Card key={facet.fieldName + idx}>
            <Card.Header>
                <FilterLink callback={() => null} eventKey={'' + idx} info={facet.description}>{facet.displayName}</FilterLink>
            </Card.Header>
            <Accordion.Collapse eventKey={'' + idx}>
                <Card.Body>
                    {facet.terms.map((option, i) => {
                        return <label className="filter-option" key={`option${i}`}>
                            <input
                                type="checkbox"
                                disabled={!option.enabled && option.count == 0}
                                checked={option.enabled}
                                onChange={(e) => change(facet.fieldName, option.term, e.target.checked)}
                            /><p>{option.displayName} ({option.count})</p>
                        </label>
                    })}
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    });

    let filterClass = 'prek-filter';
    if (appContext.mode == PAGE_MODE.GOCPS) {
        filterClass = 'cps-filter';
    }
    else if (appContext.mode == PAGE_MODE.SUMMER_PROGRAMM) {
        filterClass = 'prog-filter';
    }
    return (
        <div className={`search-filters ${filterClass}`}>
            <button className="filters-handle" aria-label="filters" onClick={() => setShow(!show)}>
                <i className="fa fa-sliders-h"></i>
                <div>Filters</div>
            </button>
            <div className="filters-title" style={{ display: show ? 'flex' : 'none' }}>
                <a className="reset-link" onClick={appContext.resetSearch}>Reset Filters</a>
                <i className="fa fa-times" onClick={() => setShow(!show)}></i>
            </div>
            <div className="search-filter-palette bs-shim" style={{ display: show ? 'initial' : 'none' }}>
                <div>
                    {appContext.mode == 'prek' ? <AgeCalculator ref={ageCalcRef} setAgeFilter={setAgeFilter} /> : <></>}
                    <Accordion defaultActiveKey="0">
                        {filterDom(finalFilters)}
                    </Accordion>
                </div>
            </div>
        </div>
    )
}
export default FilterForm;